import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { getSessionId } from "./utils/authStorage";

const fetchOriginal = window.fetch.bind(window);
const backendUrl = new URL(process.env.VUE_APP_BACKEND_URL, window.location.href);

window.fetch = (resource, options = {}) => {
  const resourceUrl = typeof resource === "string" ? resource : resource.url;
  let requestUrl;

  try {
    requestUrl = new URL(resourceUrl, window.location.href);
  } catch (error) {
    return fetchOriginal(resource, options);
  }

  if (requestUrl.origin !== backendUrl.origin) {
    return fetchOriginal(resource, options);
  }

  const headers = new Headers(resource instanceof Request ? resource.headers : undefined);
  new Headers(options.headers).forEach((value, name) => headers.set(name, value));

  const sessionId = getSessionId();
  if (sessionId) headers.set("x-session-id", sessionId);

  return fetchOriginal(resource, { ...options, headers });
};

// Bloquear o inspecionar

// document.addEventListener("contextmenu", (event) => {
//   if (event.target.closest("input, textarea, select, [contenteditable='true']")) return;
//   event.preventDefault();
// });

// document.addEventListener("keydown", (event) => {
//   const tecla = event.key.toLowerCase();
//   const modificador = event.ctrlKey || event.metaKey;
//   const atalhoDevTools = modificador && event.shiftKey && ["i", "j", "c"].includes(tecla);
//   const verCodigoFonte = modificador && tecla === "u";

//   if (event.key === "F12" || atalhoDevTools || verCodigoFonte) {
//     event.preventDefault();
//     event.stopPropagation();
//   }
// }, true);

const app = createApp(App);

app.use(router);

function inicializarAnalytics() {
  if (window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", "G-683F32121G", { anonymize_ip: true });

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-683F32121G";
  document.head.appendChild(script);
}

if (localStorage.getItem("wisecalc.cookie-consent") === "accepted") {
  inicializarAnalytics();
}

window.addEventListener("wisecalc:cookie-consent", (event) => {
  if (event.detail === "accepted") inicializarAnalytics();
});

app.mount("#app");
